export default __webpack_public_path__ + "static/media/scikitlearn.73b2a863.svg";